var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackReriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33288 15.4996C1.3993 15.5076 1.46645 15.5076 1.53288 15.4996L4.86621 14.6662C5.01408 14.6311 5.14952 14.5561 5.25788 14.4496L15.4995 4.17455C15.81 3.86228 15.9842 3.43986 15.9842 2.99955C15.9842 2.55924 15.81 2.13682 15.4995 1.82455L14.1829 0.499553C14.0281 0.344593 13.8443 0.221661 13.6419 0.137787C13.4396 0.0539133 13.2227 0.0107422 13.0037 0.0107422C12.7847 0.0107422 12.5678 0.0539133 12.3655 0.137787C12.1631 0.221661 11.9793 0.344593 11.8245 0.499553L1.58288 10.7412C1.4752 10.8501 1.39767 10.985 1.35788 11.1329L0.524543 14.4662C0.494591 14.574 0.486664 14.6868 0.501233 14.7978C0.515803 14.9087 0.552571 15.0156 0.609344 15.112C0.666118 15.2085 0.741733 15.2925 0.83168 15.3591C0.921627 15.4256 1.02406 15.4734 1.13288 15.4996C1.1993 15.5076 1.26645 15.5076 1.33288 15.4996ZM12.9995 1.67455L14.3245 2.99955L12.9995 4.32455L11.6829 2.99955L12.9995 1.67455ZM2.92454 11.7579L10.4995 4.17455L11.8245 5.49955L4.24121 13.0829L2.48288 13.5162L2.92454 11.7579Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackReriod);
export default __webpack_public_path__ + "static/media/feedback_reriod.6febb2409f106db50cec006d56931ed3.svg";
export { ForwardRef as ReactComponent };